<!--
 * @Version: 1.2
 * @Author: admin
 * @Description: chart
 * @Date: 2022-06-23 14:44:40
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 11:38:26
-->
<template>
  <VCharts
    v-if="renderChart"
    ref="chartRef"
    :option="options"
    :autoresize="autoresize"
    :style="{ width, height }"
    :update-options="{ notMerge: true }"
  />
</template>

<script lang="ts" setup>
  import "echarts/lib/component/title";
  import { ref, nextTick } from "vue";
  import VCharts from "vue-echarts";
  // import { useAppStore } from '@/store';

  defineProps({
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    autoresize: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  });
  // const appStore = useAppStore();
  // const theme = computed(() => {
  //   if (appStore.theme === 'dark') return 'dark';
  //   return '';
  // });
  const renderChart = ref(false);
  const chartRef = ref<any>(null);
  
  // wait container expand
  nextTick(() => {
    renderChart.value = true;
  });
  
  // 暴露图表实例
  defineExpose({
    chart: chartRef,
    getChartInstance: () => {
      // vue-echarts 的实例通过多种方式尝试获取
      if (!chartRef.value) {
        return null;
      }
      
      // 方式1: 通过 getEchartsInstance 方法（vue-echarts 6.x）
      if (typeof chartRef.value.getEchartsInstance === 'function') {
        return chartRef.value.getEchartsInstance();
      }
      
      // 方式2: 通过 chart 属性
      if (chartRef.value.chart) {
        return chartRef.value.chart;
      }
      
      // 方式3: 直接返回（vue-echarts 5.x 或更早版本）
      if (typeof chartRef.value.dispatchAction === 'function') {
        return chartRef.value;
      }
      
      // 方式4: 通过 $el 获取 DOM 上的实例
      if (chartRef.value.$el) {
        const dom = chartRef.value.$el.querySelector('div');
        if (dom && (dom as any).__echarts_instance__) {
          return (dom as any).__echarts_instance__;
        }
      }
      
      return null;
    }
  });
</script>

<style scoped lang="less"></style>
